import React from 'react';
import { Box, HStack } from '@chakra-ui/react';
import { keyframes } from '@emotion/react';
import { motion } from 'framer-motion';
import BubbleTail from '@components/atoms/BubbleTail';

const animationKeyframes = keyframes`
  0% { transform: scale(1) rotate(0); border-radius: 50%; }
  50% { transform: scale(1) rotate(0) translateY(-50%); border-radius: 50%; }
  75% { transform: scale(1) rotate(0) translateY(0%); border-radius: 50%; }
  100% { transform: scale(1) rotate(0) translateY(0); border-radius: 50%; }
`;

const animation = ({ speed = 1, delay = 0 }) =>
  `${animationKeyframes} ${speed}s ease-in-out ${delay}s infinite`;

const Dot = ({ delay = 0 }) => (
  <Box
    as={motion.div}
    animation={animation({ speed: 0.5, delay })}
    borderRadius="50%"
    bg="white"
    width="0.363rem"
    height="0.363rem"
  />
);

const BounceDots = ({
  animate,
  variants,
  initial,
  flatten = false,
  ...props
}) => {
  return (
    <HStack
      h={flatten ? `0` : `auto`}
      spacing="0.363rem"
      w="max-content"
      bg="purple.400"
      p={flatten ? `0` : `1.25rem 1rem`}
      pos="relative"
      zIndex="10"
      // Motion props
      as={motion.div}
      variants={variants}
      animate={animate}
      initial={initial}
      {...props}>
      <Dot delay="0.1" />
      <Dot delay="0.2" />
      <Dot delay="0.3" />
      <BubbleTail bgColour="#7D55C7" bottom="5px" left="-12px" />
    </HStack>
  );
};

export default BounceDots;
